import { render } from "./GetStartedSection.vue?vue&type=template&id=1cc3b0f8&scoped=true"
import script from "./GetStartedSection.vue?vue&type=script&lang=js"
export * from "./GetStartedSection.vue?vue&type=script&lang=js"

import "./GetStartedSection.vue?vue&type=style&index=0&id=1cc3b0f8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cc3b0f8"]])

export default __exports__